import { useState } from 'react'
import { useAuth } from '../app/auth'
import { AttendanceBar } from '../attendance/AttendanceBar'
import { CorrectionRequestForm } from '../corrections/CorrectionRequestForm'
import { MyJobCard } from './MyJobCard'
import { selectMyOpenJobs } from './myjobs'
import { useOrdersList } from './useOrders'

/**
 * Meine Liste: die mir zugewiesenen offenen Aufträge zum Abarbeiten, jeweils mit Zeiterfassung, plus die
 * große Stempel-Leiste (Kommen/Gehen/Pause) wie im Alt-Monolithen (renderWerkstatt(false)). Die Leiste
 * teilt sich Hooks + persistenten Stand mit der Header-Stempeluhr.
 */
export function MyJobsList() {
  const { user } = useAuth()
  const { data, isLoading, error } = useOrdersList()
  const [correcting, setCorrecting] = useState(false)
  const [correctionSent, setCorrectionSent] = useState(false)

  if (isLoading) return <div className="muted">Aufträge werden geladen…</div>
  if (error) {
    return (
      <div className="error" role="alert">
        Aufträge konnten nicht geladen werden.
      </div>
    )
  }

  const jobs = selectMyOpenJobs(data?.orders ?? [], user?.id ?? -1)

  return (
    <section className="wf-view">
      <div>
        <h2 className="viewtitle">Meine Liste</h2>
        <p className="sub">Heute zugewiesen · von oben nach unten abarbeiten</p>
      </div>

      <AttendanceBar />

      <div className="wf-corrbar">
        {correctionSent ? (
          <span className="wf-corrbar__sent" role="status">
            Anfrage an den Chef gesendet ✓
          </span>
        ) : null}
        <button
          type="button"
          className="wf-btn wf-btn--ghost wf-btn--sm"
          aria-expanded={correcting}
          onClick={() => {
            setCorrecting((open) => !open)
            setCorrectionSent(false)
          }}
        >
          Zeit-Korrektur anfragen
        </button>
      </div>
      {correcting ? (
        <CorrectionRequestForm
          onClose={() => setCorrecting(false)}
          onSent={() => {
            setCorrecting(false)
            setCorrectionSent(true)
          }}
        />
      ) : null}

      <div className="wf-sectionhead">
        <h3>Heute zugewiesen</h3>
        <span className="wf-count">{jobs.length}</span>
      </div>
      {jobs.length === 0 ? (
        <div className="wf-empty">
          <div className="wf-empty__title">Nichts offen</div>
          <div className="wf-empty__text">Dir sind aktuell keine offenen Aufträge zugewiesen.</div>
        </div>
      ) : (
        <div className="wf-joblist">
          {jobs.map((order) => (
            <MyJobCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </section>
  )
}
